import Docket from "../../entities/docket";

/**
 * Docket actions
 *
 * Call order:
 *
 * DOCKET_SAVE_QUEUE:	adds the item to the save queue
 * --> DOCKET_SAVE:	modifies the state
 * --> DOCKET_SAVE_SUCCESS: if all went well
 * --> DOCKET_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail DOCKET_SAVE_QUEUE is during the call to DOCKET_SAVE,
 * as adding an item to the queue should never fail.
 */

export const DOCKET_FETCH_ONE_QUEUE: any = 'DOCKET_FETCH_ONE_QUEUE';
export const DOCKET_FETCH_SUCCESS: any = 'DOCKET_FETCH_SUCCESS';
export const DOCKET_FETCH_FAILURE: any = 'DOCKET_FETCH_FAILURE';
export const DOCKET_FETCH_ONE_SUCCESS: any = 'DOCKET_FETCH_ONE_SUCCESS';
export const DOCKET_FETCH_ONE_FAILURE: any = 'DOCKET_FETCH_ONE_FAILURE';

export const DOCKET_SAVE: any = 'DOCKET_SAVE';
export const DOCKET_SAVE_QUEUE: any = 'DOCKET_SAVE_QUEUE';
export const DOCKET_SAVE_SUCCESS: any = 'DOCKET_SAVE_SUCCESS';
export const DOCKET_SAVE_FAILURE: any = 'DOCKET_SAVE_FAILURE';

export const DOCKET_SAVE_MANY: any = 'DOCKET_SAVE_MANY';
export const DOCKET_SAVE_MANY_QUEUE: any = 'DOCKET_SAVE_MANY_QUEUE';
export const DOCKET_SAVE_MANY_SUCCESS: any = 'DOCKET_SAVE_MANY_SUCCESS';
export const DOCKET_SAVE_MANY_FAILURE: any = 'DOCKET_SAVE_MANY_FAILURE';

export const DOCKET_REMOVE: any = 'DOCKET_REMOVE';
export const DOCKET_REMOVE_QUEUE: any = 'DOCKET_REMOVE_QUEUE';
export const DOCKET_REMOVE_SUCCESS: any = 'DOCKET_REMOVE_SUCCESS';
export const DOCKET_REMOVE_FAILURE: any = 'DOCKET_REMOVE_FAILURE';

export const DOCKET_RESTORE: any = 'DOCKET_RESTORE';
export const DOCKET_RESTORE_QUEUE: any = 'DOCKET_RESTORE_QUEUE';
export const DOCKET_RESTORE_SUCCESS: any = 'DOCKET_RESTORE_SUCCESS';
export const DOCKET_RESTORE_FAILURE: any = 'DOCKET_RESTORE_FAILURE';

export const DOCKET_RESTORE_MANY: any = 'DOCKET_RESTORE_MANY';
export const DOCKET_REMOVE_MANY: any = 'DOCKET_REMOVE_MANY';

/* Fetch actions */
export const fetchDocketSuccess = (dockets: Docket[], partial: boolean, lastFetch: number) => ({type: DOCKET_FETCH_SUCCESS, dockets, partial, lastFetch});
export const fetchDocketFailure = (err: any) => {
		console.error('DocketAction: fetchDocketFailure', err);
		return {type: DOCKET_FETCH_FAILURE, err};
};
export const fetchOneDocketQueue = (docketId: string) => ({type: DOCKET_FETCH_ONE_QUEUE, docketId});
export const fetchOneDocketSuccess = (docket: Docket) => ({type: DOCKET_FETCH_ONE_SUCCESS, docket});
export const fetchOneDocketFailure = (id: string, err: any) => {
		console.error('DocketAction: fetchOneDocketFailure', err);
		return {type: DOCKET_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveDocket = (docket: Docket) => {
    // console.debug('⮂ DOCKET_SAVE action', docket?.id);
    return {type: DOCKET_SAVE, docket};
}
export const saveDocketQueue = (docket: Docket, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ DOCKET_SAVE_QUEUE action', docket?.id);
    return {type: DOCKET_SAVE_QUEUE, docket, onQueued};
}
export const saveDocketSuccess = (docket: Docket) => {
    // console.debug('⮂ DOCKET_SAVE_SUCCESS action', docket?.id);
    return {type: DOCKET_SAVE_SUCCESS, docket};
}
export const saveDocketFailure = (docket: Docket, status: number, message: string) => {
    console.warn(`⮂ DOCKET_SAVE_FAILURE error saving docket: HTTP ${status}: ${message}`, docket?.id);
    return {type: DOCKET_SAVE_FAILURE, docket, status, message};
};

/* SaveMany actions */
export const saveManyDockets = (dockets: Docket[]) => {
    // console.debug('⮂ DOCKET_SAVE_MANY action', dockets?.map(docket => docket?.id).join(','));
    return {type: DOCKET_SAVE_MANY, dockets};
}
export const saveManyDocketsQueue = (dockets: Docket[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ DOCKET_SAVE_MANY_QUEUE action', dockets?.map(docket => docket.id).join(','));
    return {type: DOCKET_SAVE_MANY_QUEUE, dockets, onQueued};
}

export const saveManyDocketsSuccess = (dockets: Docket[]) => {
    // console.debug('⮂ DOCKET_SAVE_MANY_SUCCESS action', dockets?.map(docket => docket.id).join(','));
    return {type: DOCKET_SAVE_MANY_SUCCESS, dockets};
}
export const saveManyDocketsFailure = (dockets: Docket[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_DOCKETS_FAILURE Error saving dockets: HTTP ${status}: ${message}`, dockets?.map(docket => docket.id).join(','));
		return {type: DOCKET_SAVE_MANY_FAILURE, dockets, status, message};
};

/* Remove actions */
export const removeDocket = (docket: Docket) => ({ type: DOCKET_REMOVE, docket });
export const removeDocketQueue = (docket: Docket) => ({ type: DOCKET_REMOVE_QUEUE, docket });
export const removeDocketSuccess = (docket: Docket) => ({ type: DOCKET_REMOVE_SUCCESS, docket });
export const removeDocketFailure = (docket: Docket, status: number, message: string) => {
	console.error(`Redux: removeDocketFailure Error removing docket: HTTP ${status}: ${message}`);
	return ({ type: DOCKET_REMOVE_FAILURE, docket, status, message });
};

/* Restore actions */
export const restoreDocket = (docket: Docket) => ({ type: DOCKET_RESTORE, docket });
export const restoreDocketQueue = (docket: Docket) => ({ type: DOCKET_RESTORE_QUEUE, docket });
export const restoreDocketSuccess = (docket: Docket) => ({ type: DOCKET_RESTORE_SUCCESS, docket });
export const restoreDocketFailure = (docket: Docket, status: number, message: string) => {
	console.error(`Redux: restoreDocketFailure Error restoring docket: HTTP ${status}: ${message}`);
	return ({ type: DOCKET_RESTORE_FAILURE, docket, status, message });
};

/* RestoreMany actions */
export const restoreManyDockets = (dockets: Docket[]) => ({ type: DOCKET_RESTORE_MANY, dockets });

/* RemoveMany actions */
export const removeManyDockets = (dockets: Docket[]) => ({ type: DOCKET_REMOVE_MANY, dockets });